import MainLogo from "../../assets/images/mainlogo.svg";

const GuestHeader = () => {
    return (
        <div className="px-[102px] py-[40px]">
            <img src={MainLogo} alt="Financial Health Score logo" />
        </div>
    );
};
export default GuestHeader;
